module.exports = __webpack_public_path__ + "static/media/Video Player 1.4af493f5.svg";